import styled from "styled-components";

export const Container = styled.div`
  width: 80%;
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const SettingsLabel = styled.div`
  font-size: 5em;
  margin-bottom: 20px;
  margin-top: 50px;
`;
export const LanguageOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin: auto;
  justify-content: space-around;
  min-width: 80%;
`;
